import { Button, Header, LoadingSpinner, WebcamPhotoCapture } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useRef, useState } from 'react'
import { StoreContext } from '@store/Root.store'

import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'

export const AddressUploadBackSideIkanoPage = observer(() => {
  const store = useContext(StoreContext)
  const { context } = store.ScenarioState
  const { isMobile } = store.AppState
  const { AddressUploadBackSideIkano: trans } = store.TranslationsState.translations

  const webcamRef = useRef<WebcamPhotoCapture>(null)
  const [photoDataUrl, setPhotoDataUrl] = useState<string | Blob | undefined>()

  const [loading, setLoading] = useState(false)

  const handleTakePhoto = async () => {
    await webcamRef.current?.takePhoto()
  }

  const handleReset = () => {
    webcamRef.current?.reset()
    setPhotoDataUrl(undefined)
  }

  const handleProceed = async () => {
    if (!photoDataUrl) return

    setLoading(true)
    await handlePhotoUpload()
    setLoading(false)

    store.ScenarioState.nextPage()
  }

  const handlePhotoUpload = async () => {
    if (!context?.documentUploadUrl) return

    try {
      await axiosInstance.post(
        context.documentUploadUrl,
        { file: photoDataUrl },
        {
          withCredentials: true,
        }
      )
    } catch (e) {
      devLog(e)
    }
  }

  return (
    <div className="page-container">
      {loading ? (
        <>
          <Header>{trans.verifying}</Header>
          <LoadingSpinner />
        </>
      ) : (
        <>
          <Header>{trans.header}</Header>

          <div className="generic__paragraph">{trans.description}</div>

          <WebcamPhotoCapture
            ref={webcamRef}
            showFrame
            onPhotoCapture={(value) => setPhotoDataUrl(value)}
          />

          <div className="layout__content-container-bottom-fixed layout__content-container-bottom-fixed--gap-16">
            {photoDataUrl ? (
              <>
                <Button className="button--secondary" onClick={handleReset}>
                  {trans.retakePhoto}
                </Button>

                <Button onClick={() => handleProceed()}>
                  <>
                    <span className="generic__button-text">{trans.proceed}</span>
                  </>
                </Button>
              </>
            ) : (
              <>
                {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
                <Button onClick={handleTakePhoto}>{trans.takePhoto}</Button>
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
})
